module.exports = __webpack_public_path__ + "img/tg.19ba5076.svg";